import { getValue } from "../../../common/getValue";

export function CONVERSION_POINT_REQUEST(state) {
  state;
  state.conversionPoint = {
    ...state.conversionPoint,
    isLoading: true
  };
}
export function CONVERSION_POINT_SUCCESS(state, payload) {
  const amount = getValue(payload.data, 'amount', 0)
  state;
  state.conversionPoint = {
    data: {
      amount: amount
    },
    status: payload.status,
    isLoading: false
  };
}
export function CONVERSION_POINT_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function UPDATE_CONVERSION_POINT_REQUEST(state) {
  state;
  state.conversionPoint = {
    ...state.conversionPoint,
    isLoading: true
  };
}
export function UPDATE_CONVERSION_POINT_SUCCESS(state, payload) {
  const amount = getValue(payload.data, 'amount', 0)
  state;
  state.conversionPoint = {
    data: {
      amount: amount
    },
    status: payload.status,
    isLoading: false
  };
}
export function UPDATE_CONVERSION_POINT_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
